import { HelpCircle, Mail, MessageSquare, Phone } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Crown } from 'lucide-react'

const Support = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-purple-900 to-slate-900">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-black/20 backdrop-blur-md border-b border-white/10">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center space-x-2">
              <Crown className="w-8 h-8 text-purple-400" />
              <span className="text-xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                Crown of Suns
              </span>
            </Link>
            <Link to="/">
              <button className="text-gray-400 hover:text-white">← Back to Home</button>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="pt-24 pb-12 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="text-center mb-12">
            <HelpCircle className="w-16 h-16 text-blue-400 mx-auto mb-6" />
            <h1 className="text-4xl font-bold text-white mb-4">Support Center</h1>
            <p className="text-xl text-gray-300">
              Need help with your galactic empire? We're here to assist you.
            </p>
          </div>

          {/* Support Options */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-6 border border-white/10 text-center">
              <Mail className="w-12 h-12 text-blue-400 mx-auto mb-4" />
              <h3 className="text-xl font-bold text-white mb-3">Email Support</h3>
              <p className="text-gray-300 mb-4">
                Send us your questions and we'll respond within 24 hours.
              </p>
              <a
                href="mailto:support@crownofsuns.com"
                className="text-blue-400 hover:text-blue-300 font-medium"
              >
                support@crownofsuns.com
              </a>
            </div>

            <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-6 border border-white/10 text-center">
              <MessageSquare className="w-12 h-12 text-green-400 mx-auto mb-4" />
              <h3 className="text-xl font-bold text-white mb-3">Live Chat</h3>
              <p className="text-gray-300 mb-4">
                Chat with our support team in real-time during business hours.
              </p>
              <button className="text-green-400 hover:text-green-300 font-medium">
                Start Chat
              </button>
            </div>

            <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-6 border border-white/10 text-center">
              <Phone className="w-12 h-12 text-purple-400 mx-auto mb-4" />
              <h3 className="text-xl font-bold text-white mb-3">Phone Support</h3>
              <p className="text-gray-300 mb-4">
                Call us for urgent issues and technical problems.
              </p>
              <span className="text-purple-400 font-medium">
                1-800-CROWN-OF-SUNS
              </span>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-8 border border-white/10">
            <h2 className="text-2xl font-bold text-white mb-6 text-center">
              Frequently Asked Questions
            </h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-semibold text-white mb-2">
                  How do I start playing Crown of Suns?
                </h3>
                <p className="text-gray-300">
                  Simply create an account, choose your faction, and begin building your galactic empire. 
                  The tutorial will guide you through the basics of fleet management, research, and diplomacy.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-white mb-2">
                  Can I play with my friends?
                </h3>
                <p className="text-gray-300">
                  Yes! Crown of Suns is a multiplayer game where you can form alliances, trade resources, 
                  and coordinate strategies with other players from around the world.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-white mb-2">
                  Is the game free to play?
                </h3>
                <p className="text-gray-300">
                  Crown of Suns offers a free-to-play experience with optional premium features. 
                  All core gameplay features are accessible without payment.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-white mb-2">
                  How do I report a bug or technical issue?
                </h3>
                <p className="text-gray-300">
                  You can report bugs through our support email or live chat. Please include as much 
                  detail as possible about the issue, including your browser, operating system, and 
                  steps to reproduce the problem.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Support